import Vue from 'vue'
import Router from 'vue-router'

console.log(location.pathname);
Vue.use(Router)
let title = '云玺科技云智能印签管控平台--'
export default new Router({
  mode: 'history',
  // base:'18080',
  routes: [{
    path: '/',
    name: 'Home',
    redirect: {
      name: 'index',
      keepAlive: true//缓存组件
    },
    meta: {
      key: 2,
      title: '首页',
      networkTitle: title + '首页',
      requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
      keepAlive: true//缓存组件
    },
    component: () => import('@/views/home/index'),
    children: [{
      path: '/index',
      meta: {
        key: 2,
        title: '首页',
        networkTitle: title + '首页',
        requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
        keepAlive: true//缓存组件
      },
      name: 'index',
      component: () => import('@/views/home/index/index')
    }, {
      path: '/myPanel',
      meta: {
        key: 2,
        title: '我的面板',
        keepAlive: true//缓存组件
      },
      name: 'myPanel',
      component: () => import('@/views/home/myPanel/myPanel'),
      children: [{
        path: '/myInfo',
        meta: {
          key: 2,
          parent_name: '我的面板', //添加父级的名字属于印章下的
          networkTitle: title + '个人信息',
          title: '个人信息',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
        },
        name: 'myInfo',
        component: () => import('@/views/home/myPanel/myInfo/myInfo')
      }, {
        path: '/changePassword',
        meta: {
          key: 2,
          parent_name: '我的面板', //添加父级的名字属于印章下的
          networkTitle: title + '修改密码',
          title: '修改密码',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'changePassword',
        component: () => import('@/views/home/myPanel/changePassword/changePassword')
      }, {
        path: '/systemMessage',
        meta: {
          key: 2,
          parent_name: '我的面板', //添加父级的名字属于印章下的
          networkTitle: title + '系统消息',
          title: '系统消息',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'systemMessage',
        component: () => import('@/views/home/myPanel/systemMessage/systemMessage')
      }, {
        path: '/myApplication',
        meta: {
          key: 2,
          parent_name: '我的面板', //添加父级的名字属于印章下的
          networkTitle: title + '我的申请',
          title: '我的申请',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
        },
        name: 'myApplication',
        component: () => import('@/views/home/myPanel/myApplication/myApplication')
      }]
    }, {
      path: '/deviceManagement',
      redirect: {
        name: 'sealManagement'
      },
      meta: {
        key: 2,
        networkTitle: title + '设备管理',
        title: '设备管理',
        keepAlive: true//缓存组件
      },
      name: 'deviceManagement',
      component: () => import('@/views/home/deviceManagement/deviceManagement'),
      children: [{
        path: '/sealManagement',
        meta: {
          key: 2,
          parent_name: '设备管理', //添加父级的名字属于印章下的
          networkTitle: title + '印章管理',
          title: '印章管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'sealManagement',
        component: () => import('@/views/home/deviceManagement/sealManagement/sealManagement')
      }]
    }, {
      path: '/organizationalStructure',
      redirect: {
        name: 'companyManagement'
      },
      meta: {
        key: 2,
        networkTitle: title + '组织架构',
        title: '组织架构',
        keepAlive: true//缓存组件
      },
      name: 'organizationalStructure',
      component: () => import('@/views/home/organizationalStructure/organizationalStructure'),
      children: [{
        path: '/companyManagement',
        meta: {
          key: 2,
          parent_name: '组织架构', //添加父级的名字属于印章下的
          networkTitle: title + '组织管理',
          title: '组织管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'companyManagement',
        component: () => import('@/views/home/organizationalStructure/companyManagement/companyManagement')
      }, {
        path: '/jobManagement',
        meta: {
          key: 2,
          parent_name: '组织架构', //添加父级的名字属于印章下的
          networkTitle: title + '职位管理',
          title: '职位管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'jobManagement',
        component: () => import('@/views/home/organizationalStructure/jobManagement/jobManagement')
      }, {
        path: '/privilegeManagement',
        meta: {
          key: 2,
          parent_name: '组织架构', //添加父级的名字属于印章下的
          networkTitle: title + '部门管理',
          title: '部门管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'privilegeManagement',
        component: () => import('@/views/home/organizationalStructure/privilegeManagement/privilegeManagement')
      }, {
        path: '/roleManagement',
        meta: {
          key: 2,
          parent_name: '组织架构', //添加父级的名字属于印章下的
          networkTitle: title + '角色管理',
          title: '角色管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'roleManagement',
        component: () => import('@/views/home/organizationalStructure/roleManagement/roleManagement')
      }, {
        path: '/personnelManagement',
        meta: {
          key: 2,
          parent_name: '组织架构', //添加父级的名字属于印章下的
          networkTitle: title + '人员管理',
          title: '人员管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'personnelManagement',
        component: () => import('@/views/home/organizationalStructure/personnelManagement/personnelManagement')
      }]
    }, {
      path: '/platformManagement',
      redirect: {
        name: 'systemPrivilegeManagement'
      },
      meta: {
        key: 2,
        networkTitle: title + '平台管理',
        title: '平台管理',
        keepAlive: true//缓存组件
      },
      name: 'platformManagement',
      component: () => import('@/views/home/platformManagement/platformManagement'),
      children: [{
        path: '/systemPrivilegeManagement',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '系统权限管理',
          title: '系统权限管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'systemPrivilegeManagement',
        component: () => import('@/views/home/platformManagement/systemPrivilegeManagement/systemPrivilegeManagement')
      }, {
        path: '/serverManagement',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '服务功能管理',
          title: '服务功能管理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'serverManagement',
        component: () => import('@/views/home/platformManagement/serverManagement/serverManagement')
      }, {
        path: '/smsNoticeSet',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '短信通知设置',
          title: '短信通知设置',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'smsNoticeSet',
        component: () => import('@/views/home/platformManagement/smsNoticeSet/smsNoticeSet')
      }, {
        path: '/QuantumManagement',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '量子传输设置',
          title: '量子传输设置',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'QuantumManagement',
        component: () => import('@/views/home/platformManagement/QuantumManagement/QuantumManagement')
      }, {
        path: '/sealConfiguration',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '印章配置设置',
          title: '印章配置设置',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'sealConfiguration',
        component: () => import('@/views/home/platformManagement/sealConfiguration/sealConfiguration')
      }, {
        path: '/appUpdate',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + 'app更新设置',
          title: 'app更新设置',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'appUpdate',
        component: () => import('@/views/home/platformManagement/appUpdate/appUpdate')
      }, {
        path: '/exceptionInfoCapture',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '异常信息捕获',
          title: '异常信息捕获',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'exceptionInfoCapture',
        component: () => import('@/views/home/platformManagement/exceptionInfoCapture/exceptionInfoCapture')
      }, {
        path: '/relocationRecord',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '迁章记录',
          title: '迁章记录',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'relocationRecord',
        component: () => import('@/views/home/platformManagement/relocationRecord/relocationRecord')
      }, {
        path: '/updateLog',
        meta: {
          key: 2,
          parent_name: '平台管理', //添加父级的名字属于印章下的
          networkTitle: title + '更新日志',
          title: '更新日志',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'updateLog',
        component: () => import('@/views/home/platformManagement/updateLog/updateLog')
      },
        {
          path: '/ExcelSealEdit',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + 'Excel导入/编辑',
            title: 'Excel导入/编辑',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'ExcelSealEdit',
          component: () => import('@/views/home/platformManagement/ExcelSealEdit/Excel')
        }, {
          path: '/SmallProgram',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + '小程序管理',
            title: '小程序管理',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'SmallProgram',
          component: () => import('@/views/home/platformManagement/weixin/SmallProgram')
        }, {
          path: '/whiteList',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + '白名单',
            title: '白名单管理',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'whiteList',
          component: () => import('@/views/home/platformManagement/whiteList/whiteList')
        },
        {
          path: '/ocrManagement',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + 'OCR管理',
            title: 'OCR管理',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'ocrManagement',
          component: () => import('@/views/home/platformManagement/ocrManagement/ocrManagement')
        },
        {
          path: '/highProfileCamera',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + '高拍仪管理',
            title: '高拍仪管理',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'highProfileCamera',
          component: () => import('@/views/home/platformManagement/highProfileCamera/highProfileCamera')
        },
        {
          path: '/logHistoryManagement',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + '日志历史',
            title: '日志历史',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'logHistoryManagement',
          component: () => import('@/views/home/platformManagement/logHistoryManagement/logHistoryManagement')
        },
        {
          path: '/ocrImageTextProbability',
          meta: {
            key: 2,
            parent_name: '平台管理', //添加父级的名字属于印章下的
            networkTitle: title + 'OCR图片置信',
            title: 'OCR图片置信',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'ocrImageTextProbability',
          component: () => import('@/views/home/platformManagement/ocrManagement/ocrImageTextProbability')
        }
      ]
    }, {
      path: '/dataManagement',
      redirect: {
        name: 'applicationChapter'
      },
      meta: {
        key: 2,
        networkTitle: title + '审批管理',
        title: '审批管理',
      },
      name: 'dataManagement',
      component: () => import('@/views/home/dataManagement/dataManagement'),
      children: [{
        path: '/applicationChapter',
        meta: {
          key: 2,
          parent_name: '审批管理', //添加父级的名字属于印章下的
          networkTitle: title + '申请用章',
          title: '申请用章',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
        },
        name: 'applicationChapter',
        component: () => import('@/views/home/dataManagement/applicationChapter/applicationChapter')
      }, {
        path: '/approvalProcessing',
        meta: {
          key: 2,
          parent_name: '审批管理', //添加父级的名字属于印章下的
          networkTitle: title + '审批管理',
          title: '审批处理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'approvalProcessing',
        component: () => import('@/views/home/dataManagement/approvalProcessing/approvalProcessing')
      }, {
        path: '/authorizationManagement',
        meta: {
          key: 2,
          parent_name: '审批管理', //添加父级的名字属于印章下的
          networkTitle: title + '授权处理',
          title: '授权处理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'authorizationManagement',
        component: () => import('@/views/home/dataManagement/authorizationManagement/authorizationManagement')
      }, {
        path: '/auditProcessing',
        meta: {
          key: 2,
          parent_name: '审批管理', //添加父级的名字属于印章下的
          networkTitle: title + '审计处理',
          title: '审计处理',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'auditProcessing',
        component: () => import('@/views/home/dataManagement/auditProcessing/auditProcessing')
      }, {
        path: '/usageRecord',
        meta: {
          key: 2,
          parent_name: '审批管理', //添加父级的名字属于印章下的
          networkTitle: title + '使用记录',
          title: '使用记录',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'usageRecord',
        component: () => import('@/views/home/dataManagement/usageRecord/usageRecord')
      }, {
        path: '/ocrCompareManagement',
        meta: {
          key: 2,
          parent_name: '审批管理', //添加父级的名字属于印章下的
          networkTitle: title + '智能OCR',
          title: '智能OCR',
          requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
          keepAlive: true//缓存组件
        },
        name: 'ocrCompareManagement',
        component: () => import('@/views/home/dataManagement/ocrCompareManagement/ocrCompareManagement')
      }]
    },
      {
        path: '/dataStatistics',
        meta: {
          key: 2,
          networkTitle: title + '数据监控',
          title: '数据监控',
          parent_name: '数据统计', //添加父级的名字属于数据管理下的
          keepAlive: true//缓存组件
        },
        name: 'dataStatistics',
        component: () => import('@/views/home/dataStatistics/dataStatistics')
      },
      {
        path: '/dataExport',
        meta: {
          key: 2,
          networkTitle: title + '数据导出',
          title: '数据导出',
          parent_name: '数据导出', //添加父级的名字属于数据管理下的
          keepAlive: true//缓存组件
        },
        name: 'dataExport',
        component: () => import('@/views/home/dataExport/dataExport')
      },
      {
        path: '/quantumLab',
        meta: {
          key: 2,
          networkTitle: title + '量子实验室',
          title: '量子实验室',
          keepAlive: true//缓存组件
        },
        redirect: {
          name: 'quantumStatistics'
        },
        name: 'quantumLab',
        component: () => import('@/views/home/quantumLab/quantumLab'),
        children: [{
          path: '/quantumStatistics',
          meta: {
            key: 2,
            parent_name: '量子实验室', //添加父级的名字属于印章下的
            networkTitle: title + '量子监控',
            title: '量子监控',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'quantumStatistics',
          component: () => import('@/views/home/quantumLab/quantumStatistics/quantumStatistics')
        }]
      },
      {
        path: '/monitoringSystem',
        meta: {
          key: 2,
          networkTitle: title + '设配监控系统',
          title: '设配监控系统',
          keepAlive: true//缓存组件
        },
        name: 'monitoringSystem',
        component: () => import('@/views/home/monitoringSystem/monitoringSystem'),
        children: [{
          path: '/equipmentMonitoring',
          meta: {
            key: 2,
            parent_name: '设配监控系统', //添加父级的名字属于印章下的
            networkTitle: title + '设备监控',
            title: '设备监控',
            requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
            keepAlive: true//缓存组件
          },
          name: 'equipmentMonitoring',
          component: () => import('@/views/home/monitoringSystem/equipmentMonitoring/equipmentMonitoring')
        }]
      },
      {
        path: '/manage_company',
        meta: {
          key: 2,
          networkTitle: title + '系统管理',
          title: '系统管理',
          keepAlive: true//缓存组件
        },
        name: 'manage_company',
        component: () => import('@/views/home/manage_company/manage_company'),
        children: [
          {
            path: '/configurationManagement',
            meta: {
              key: 2,
              parent_name: '系统管理', //添加父级的名字属于印章下的
              networkTitle: title + '配置管理',
              title: '配置管理',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'configurationManagement',
            component: () => import('@/views/home/manage_company/configurationManagement/configurationManagement')
          },
          {
            path: '/process_manage',
            meta: {
              key: 2,
              parent_name: '系统管理', //添加父级的名字属于印章下的
              networkTitle: title + '流程管理',
              title: '流程管理',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'process_manage',
            component: () => import('@/views/home/manage_company/process_manage/process_manage')
          }, {
            path: '/processSetting',
            meta: {
              key: 2,
              parent_name: '系统管理', //添加父级的名字属于印章下的
              networkTitle: title + '流程设置',
              title: '流程设置',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'processSetting',
            component: () => import('@/views/home/manage_company/processSetting/processSetting')
          }, {
            path: '/message_manage',
            meta: {
              key: 2,
              parent_name: '系统管理', //添加父级的名字属于印章下的
              networkTitle: title + '通知管理',
              title: '通知管理',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'message_manage',
            component: () => import('@/views/home/manage_company/message_manage/message_manage')
          }
        ]
      }, {
        path: '/securityPolicy',
        meta: {
          key: 2,
          networkTitle: title + '安全策略',
          title: '安全策略',
          keepAlive: true//缓存组件
        },
        name: 'securityPolicy',
        component: () => import('@/views/home/securityPolicy/securityPolicy'),
        children: [
          {
            path: '/passwordRules',
            meta: {
              key: 2,
              parent_name: '安全策略', //添加父级的名字属于印章下的
              networkTitle: title + '密码规则',
              title: '密码规则',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'passwordRules',
            component: () => import('@/views/home/securityPolicy/passwordRules/passwordRules')
          }, {
            path: '/threshold',
            meta: {
              key: 2,
              parent_name: '安全策略', //添加父级的名字属于印章下的
              networkTitle: title + '阈值设置',
              title: '阈值设置',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'threshold',
            component: () => import('@/views/home/securityPolicy/threshold/threshold')
          }, {
            path: '/remoteControl',
            meta: {
              key: 2,
              parent_name: '安全策略', //添加父级的名字属于印章下的
              networkTitle: title + '远程控制',
              title: '远程控制',
              requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
              keepAlive: true//缓存组件
            },
            name: 'remoteControl',
            component: () => import('@/views/home/securityPolicy/remoteControl/remoteControl')
          },

        ]
      }]
  },
    {
      path: '/login',
      name: 'login',
      meta: {
        key: 1,
        networkTitle: title + '登录',
        title: '登录',
      },
      component: () => import('@/views/login/index')
    },
    {
      path: '/exportUseRecord',
      name: 'exportUseRecord',
      meta: {
        key: 1,
        networkTitle: title + '申请导出',
        title: '申请导出',
      },
      component: () => import('@/views/home/dataManagement/exportUseRecord/exportUseRecord')
    },
    {
      path: '/regist',
      name: 'regist',
      meta: {
        key: 1,
        title: '注册',
        networkTitle: title + '注册',
      },
      component: () => import('@/views/regist/regist')
    },
    {
      path: '/regist_org',
      name: 'regist_org',
      meta: {
        key: 1,
        title: '公司注册',
        networkTitle: title + '公司注册',
      },
      component: () => import('@/views/regist/regist_org')
    },
    {
      path: '/resetPwd',
      name: 'resetPwd',
      meta: {
        key: 1,
        title: '重置密码',
        networkTitle: title + '重置密码',
      },
      component: () => import('@/views/regist/resetPwd')
    },
    {
      path: '/agreement',
      meta: {
        key: 2,
        parent_name: '平台管理', //添加父级的名字属于印章下的
        networkTitle: title + '用户协议和隐私政策',
        title: '用户协议和隐私政策',
        requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
        keepAlive: true//缓存组件
      },
      name: 'agreement',
      component: () => import('@/views/agreement/agreement')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js